/*import {Swiper, Pagination, A11y, Navigation} from 'swiper';*/

import {setSliderCirclesAnimation} from './utils/animations';
import {throttle, fixToIntPixel, loadLibrary} from './modules/Util';
import {LIB_URL} from './App';

const DESKTOP_WIDTH = 1490;
const direction = {
    FORWARD: `FORWARD`,
    BACK: `BACK`,
};
const selectorSlider = {
    bannerMultiple: `.slider-banner--multiple`,
    reBannerMultiple: `.re-slider-banner--multiple`,
    bannerSingle: `.slider-banner--single`,
    news: `.slider-news`,
    reNews: `.re-slider-news--`,
    products: `.slider-products`,
    bannerConstructor: `.slider-banner--constructor`,
    reSlider: `.re-slider`,
    reSliderCardio: `.re-slider-cardio`,
    reSliderStories: `.re-slider-stories`,
    reSliderMobile: `.re-slider-mobile`,
    reSliderPopular: `.re-slider-popular`,
    reSliderAjax: `.re-slider-ajax`,
    sliderSteps: `.js-swiper-steps`,
    sliderStepsThumb: `.js-swiper-steps-thumb`
};

const calculatingWidth = () => window.innerWidth >= DESKTOP_WIDTH;
let isInit = false;
let isDesktopWidth = calculatingWidth();
let sliderNews;
let sliderReNews;
let sliderSteps;
let sliderStepsThumb;

const setMargins = (currentDirection, slides, previousIndex, activeIndex) => {
    for (let i = 0; i < slides.length; i++) {
        slides[i].style.opacity = `1`;
    }
    try {
        if (slides[activeIndex + 3]) slides[activeIndex + 3].style.opacity = `0.3`;
        if (slides[activeIndex - 3]) slides[activeIndex - 3].style.opacity = `0.3`;

        if (slides[activeIndex + 2]) slides[activeIndex + 2].style.opacity = `0.3`;
        if (slides[activeIndex - 2]) slides[activeIndex - 2].style.opacity = `0.3`;
    } catch (err) {
        console.log(err);
    }
};

/*Swiper.use([Pagination, A11y, Navigation]);*/

let sliderAutoplaySpeed = $(selectorSlider.bannerMultiple).data('autoplay') || 9999999;
const multipleBannerSwiper = {
    init: () => loadLibrary(LIB_URL.SWIPER, () => {
        new Swiper(selectorSlider.bannerMultiple, {
            slidesPerView: 1,
            loop: true,
            autoplay: {
                delay: sliderAutoplaySpeed,
                disableOnInteraction: false
            },
            pagination: {
                el: `.slider-banner__pagination`,
                bulletClass: `slider-banner__pagination-item`,
                bulletActiveClass: `slider-banner__pagination-item--active`,
                clickable: true,
            },
            on: {
                init() {
                    setSliderCirclesAnimation(selectorSlider.bannerMultiple, this.activeIndex);
                },
                slideChange() {
                    setSliderCirclesAnimation(selectorSlider.bannerMultiple, this.activeIndex);
                },
                transitionEnd() {
                    fixToIntPixel(this);
                },
            }
        });
    })
};

let reSliderAutoplaySpeed = $(selectorSlider.reBannerMultiple).data('autoplay') || 9999999;
const multipleReBannerSwiper = {
    init: () => loadLibrary(LIB_URL.SWIPER, () => {
        new Swiper(selectorSlider.reBannerMultiple, {
            slidesPerView: 1,
            loop: true,
            autoplay: {
                delay: reSliderAutoplaySpeed,
                disableOnInteraction: false
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            pagination: {
                el: `.re-slider-banner__pagination`,
                bulletClass: `re-slider-banner__pagination-item`,
                bulletActiveClass: `re-slider-banner__pagination-item--active`,
                clickable: true,
            },
            on: {
                init() {
                    setSliderCirclesAnimation(selectorSlider.reBannerMultiple, this.activeIndex);
                },
                slideChange() {
                    setSliderCirclesAnimation(selectorSlider.reBannerMultiple, this.activeIndex);
                },
                transitionEnd() {
                    fixToIntPixel(this);
                },
            }
        });
    })
};

const reSlider = {
    init: () => loadLibrary(LIB_URL.SWIPER, () => {
        reSlider.swiper = new Swiper(selectorSlider.reSlider, {
            slidesPerView: 1.2,
            loop: false,
            speed: 300,
            touchRatio: 0.5,
            spaceBetween: 20,
            centeredSlides: true,
            grabCursor: true,
            watchOverflow: true,
            a11y: {
                prevSlideMessage: `Вперёд`,
                nextSlideMessage: `Назад`,
            },
            pagination: {
                el: `.re-slider__pagination`,
                bulletClass: `re-slider__pagination-item`,
                bulletActiveClass: `re-slider__pagination-item--active`,
                clickable: true,
            },
            breakpoints: {
                0: {
                    centeredSlides: false,
                    slidesPerView: 1.1,
                },
                420:{
                    centeredSlides: false,
                    slidesPerView: 1.2,
                },
                680:{
                    centeredSlides: false,
                    slidesPerView: 1.8,
                },
                768: {
                    centeredSlides: false,
                    slidesPerView: 2.4,
                },
                1257: {
                    slidesPerView: `auto`,
                    centeredSlides: false,
                    init: false,
                    freeMode: false,
                    freeModeSticky: false,
                    grabCursor: false,
                    allowTouchMove: false,
                },
            },
            on: {
                slideNextTransitionStart() {
                    isInit = true
                },
                transitionEnd() {
                    fixToIntPixel(this);
                },
                resize() {
                    isDesktopWidth = calculatingWidth();
                }
            }
        });

        setTimeout(() => {
            App.W.on('resized', reinitReSlider);
        }, 500);
    })
};

function reinitReSlider() {
    App.W.off('resized', reinitReSlider);
    if (reSlider.swiper && reSlider.swiper.destroy) reSlider.swiper.destroy();
    if (reSlider.swiper && reSlider.swiper[0]){
        reSlider.swiper.forEach((slider) => slider.destroy());
    }
    reSlider.swiper = null;
    reSlider.init();
}

window.reSliderCardioArr = [];
const reSliderCardio = {
    init: (initTag = '') => loadLibrary(LIB_URL.SWIPER, () => {
        const initTagsExtra = ['.news-tag','.products-tag'];
        const slidesDeskCount = initTagsExtra.includes(initTag) ? 4 : 3;

        const selector = selectorSlider.reSliderCardio+initTag;

        const nextEl = '.swiper-button-next'+initTag+'__btn';
        const prevEl = '.swiper-button-prev'+initTag+'__btn';

        const slidesPerView = initTag === ".stories-tag" ? 'auto' : 1.2;
        const centeredSlides = initTag === ".stories-tag";
        const breakpoints = initTag === ".stories-tag" ? {} :
            {
            0: {
                slidesPerView: 1,
            },
            420:{
                slidesPerView: 1.0,
            },
            680:{
                slidesPerView: 1.8,
            },
            768: {
                slidesPerView: 2,
            },
            960:{
                slidesPerView: 3,
            },
            1490: {
                slidesPerView: slidesDeskCount
            },
        }

        reSliderCardio.swiper = new Swiper(selector, {
            slidesPerView,
            loop: false,
            speed: 300,
            touchRatio: 0.5,
            spaceBetween: 30,
            centeredSlides,
            grabCursor: true,
            a11y: {
                prevSlideMessage: `Вперёд`,
                nextSlideMessage: `Назад`,
            },
            pagination: {
                el: `.re-slider-cardio__pagination`,
                bulletClass: `re-slider-cardio__pagination-item`,
                bulletActiveClass: `re-slider-cardio__pagination-item--active`,
                clickable: true,
            },
            navigation: {
                nextEl,
                prevEl,
            },
            scrollbar: {
                el: ".re-slider-cardio__scrollbar",
                hide: false,
            },
            breakpoints,
            on: {
                slideNextTransitionStart() {
                    isInit = true
                },
                transitionEnd() {
                    fixToIntPixel(this);
                },
                resize() {
                    isDesktopWidth = calculatingWidth();
                }
            }
        });
        reSliderCardioArr.push(reSliderCardio.swiper);


        setTimeout(() => {
            App.W.on('resized', reInitReSliderCardio);
        }, 500);
    })
};

function reSliderCardioTagSwapper(sliderContainer) {
    return sliderContainer.classList.contains("news-tag") ?
        '.news-tag' :
        sliderContainer.classList.contains("webinars-tag") ?
            '.webinars-tag' :
            sliderContainer.classList.contains("products-tag") ?
                '.products-tag' :
                sliderContainer.classList.contains("stories-tag") ? '.stories-tag' : ''
}

function reInitReSliderCardio() {
    App.W.off('resized', reInitReSliderCardio);
    if (reSliderCardio.swiper && reSliderCardio.swiper.destroy) reSliderCardio.swiper.destroy();
    if (reSliderCardioArr && reSliderCardioArr.length){
        reSliderCardioArr.forEach((slider) => slider.destroy());
    }
    reSliderCardio.swiper = null;
    window.reSliderCardioArr = [];

    const cardioSliders = document.querySelectorAll(selectorSlider.reSliderCardio);
    cardioSliders.forEach(function(sliderContainer) {
        const tag = reSliderCardioTagSwapper(sliderContainer);
        reSliderCardio.init(tag);
    });
}

const reSliderStories = {
    init: () => loadLibrary(LIB_URL.SWIPER, () => {
        reSlider.swiper = new Swiper(selectorSlider.reSliderStories, {
            slidesPerView: 'auto',
            speed: 300,
            touchRatio: 0.5,
            spaceBetween: 20,
            centeredSlides: true,
            grabCursor: true,
            watchOverflow: true,
            a11y: {
                prevSlideMessage: `Вперёд`,
                nextSlideMessage: `Назад`,
            },
            navigation: {
                nextEl: '.swiper-button-next.re-slider-stories__btn',
                prevEl: '.swiper-button-prev.re-slider-stories__btn',
            },
            pagination: {
                el: `.re-slider-stories__pagination`,
                bulletClass: `re-slider-stories__pagination-item`,
                bulletActiveClass: `re-slider-stories__pagination--active`,
                clickable: true,
            },
            effect: 'coverflow',
            loop: true,
            watchOverFlow: true,
            coverflowEffect: {
                rotate: 0,
                stretch: 80,
                depth: 200,
                modifier: 1,
                slideShadows: false,
            },
            on: {
                slideNextTransitionStart() {
                    isInit = true
                },
                transitionEnd() {
                    fixToIntPixel(this);
                },
                resize() {
                    isDesktopWidth = calculatingWidth();
                }
            }
        });

        setTimeout(() => {
            App.W.on('resized', reinitReSliderStories);
        }, 500);
    }),
    destroy: () => {
        if (reSliderStories.swiper && reSliderStories.swiper.destroy) reSliderStories.swiper.destroy();
        if (reSliderStories.swiper && reSliderStories.swiper[0]){
            reSliderStories.swiper.forEach((slider) => slider.destroy());
        }
        reSliderStories.swiper = null;
    }
};

function reinitReSliderStories() {
    App.W.off('resized', reinitReSlider);
    reSliderStories.destroy();
    reSliderStories.init();
}

const reSliderPopular = {
    init: () => loadLibrary(LIB_URL.SWIPER, () => {
        const selector = document.querySelector(selectorSlider.reSliderPopular);
        if (selector) {
            if (reSliderAjax.swiper) reSliderAjax.swiper.destroy()
            reSliderPopular.swiper = new Swiper(selectorSlider.reSliderPopular, {
                slidesPerView: 'auto',
                loop: false,
                speed: 300,
                spaceBetween: 10,
                centeredSlides: false,
                grabCursor: true,
                a11y: {
                    prevSlideMessage: `Вперёд`,
                    nextSlideMessage: `Назад`,
                },
                pagination: {
                    el: `.re-slider-popular__pagination`,
                    bulletClass: `re-slider-popular__pagination-item`,
                    bulletActiveClass: `re-slider-popular__pagination-item--active`,
                    clickable: true,
                },
                breakpoints: {
                    767: {
                        centeredSlides: false,
                    },
                    1490: {
                        centeredSlides: false,
                        spaceBetween: 30,
                    },
                },
                on: {
                    slideNextTransitionStart() {
                        isInit = true
                    },
                    transitionEnd() {
                        fixToIntPixel(this);
                    },
                    resize() {
                        isDesktopWidth = calculatingWidth();
                    }
                }
            });
        }
        setTimeout(() => {
            App.W.on('resized', reinitReSliderPopular);
            $('.js-search-refresh').on('click', refreshReSliderPopular);
        }, 500);
    })
};

// Реализиция перенесена из main.js!
const dataContactsBlockTabsSwiper = {
    init: () => loadLibrary(LIB_URL.SWIPER, () => {
        let indexProductLinksBlockList = {}

        new Swiper($('[data-contacts-block-tabs-swiper]')[0], {
            slidesPerView: 'auto',
            spaceBetween: 10,
            on:{
                init: (swiper) => {
                    if($(window).width() < 760){
                        swiper.slides.forEach((el, i) => {
                            indexProductLinksBlockList[i] = el.getBoundingClientRect().left - 16
                        })
                    }
                }
            }
        });

        if ($('[data-contacts-block-tab]').length) {
            const wrapper = $('[data-contacts-block-tabs-swiper]').find('.swiper-wrapper');
            const $slides = $('[data-contacts-block-tab]');

            $slides.each(function () {
                $(this).on('click', function () {
                    const count = $(this).attr('data-contacts-block-tab')
                    $('[data-contacts-block-tab]').each(function () {
                        $(this).removeClass('active')
                    })
                    $(this).addClass('active')
                    if($(window).width() < 767 && wrapper.length){
                        let indexEl = $(this).index();
                        $(wrapper[0]).css({
                            "-webkit-transform":`translate(-${Math.abs(indexProductLinksBlockList[indexEl])}px,0)`,
                            "transition" : "all 0.6s linear"
                        });
                    }
                    $('[data-contacts-block-tabs-content]').each(function () {
                        if ($(this).attr('data-contacts-block-tabs-content') === count) {
                            $(this).addClass('active')
                        } else {
                            $(this).removeClass('active')
                        }
                    })
                })

                if ($(this).hasClass('active')) {
                    $(this).trigger('click');
                }
            })
        }
    })
}

function reinitReSliderPopular() {
    App.W.off('resized', reinitReSliderPopular);
    $('.js-search-refresh').off('click', refreshReSliderPopular);
    if (reSliderPopular.swiper && reSliderPopular.swiper.destroy) reSliderPopular.swiper.destroy();
    if (reSliderPopular.swiper && reSliderPopular.swiper[0]){
        reSliderPopular.swiper.forEach((slider) => slider.destroy());
    }
    reSliderPopular.swiper = null;
    reSliderPopular.init();
}

function refreshReSliderPopular() {
    setTimeout(() => {
        if (reSliderPopular.swiper && reSliderPopular.swiper.update)
            reSliderPopular.swiper.update();

        if (reSliderPopular.swiper && reSliderPopular.swiper[0]){
            reSliderPopular.swiper.forEach((slider) => slider.update());
        }
    }, 200);
}


const reSliderAjax = {
    init: () => loadLibrary(LIB_URL.SWIPER, () => {
        const selector = document.querySelector(selectorSlider.reSliderAjax);
        console.log(777, selector)
        if (selector) {
            if (reSliderAjax.swiper) reSliderAjax.swiper.destroy()
            reSliderAjax.swiper = new Swiper(selectorSlider.reSliderAjax, {
                slidesPerView: 'auto',
                loop: false,
                speed: 300,
                spaceBetween: 10,
                centeredSlides: true,
                grabCursor: true,
                pagination: {
                    el: `.re-slider-ajax__pagination`,
                    bulletClass: `re-slider-ajax__pagination-item`,
                    bulletActiveClass: `re-slider-ajax__pagination-item--active`,
                    clickable: true,
                },
                breakpoints: {
                    767: {
                        centeredSlides: false,
                    },
                    1490: {
                        centeredSlides: false,
                        spaceBetween: 45,
                    },
                },
                on: {
                    slideNextTransitionStart() {
                        isInit = true
                    },
                    transitionEnd() {
                        fixToIntPixel(this);
                    },
                    resize() {
                        isDesktopWidth = calculatingWidth();
                    }
                }
            });

            setTimeout(() => {
                App.W.on('resized', reinitReSliderAjax);
                $('.js-search-refresh').on('click', refreshReSliderAjax);
            }, 500);
        }
    })
};

function reinitReSliderAjax() {
    App.W.off('resized', reinitReSliderAjax);
    $('.js-search-refresh').off('click', refreshReSliderAjax);
    if (reSliderAjax.swiper && reSliderAjax.swiper.destroy) reSliderAjax.swiper.destroy();
    if (reSliderAjax.swiper && reSliderAjax.swiper[0]){
        reSliderAjax.swiper.forEach((slider) => slider.destroy());
    }
    reSliderAjax.swiper = null;
    reSliderAjax.init();
}

function refreshReSliderAjax() {
    setTimeout(() => {
        if (reSliderAjax.swiper && reSliderAjax.swiper.update)
            reSliderAjax.swiper.update();

        if (reSliderAjax.swiper && reSliderAjax.swiper[0]){
            reSliderAjax.swiper.forEach((slider) => slider.update());
        }
    }, 500);
}

const reSliderMobile = {
    init: () => loadLibrary(LIB_URL.SWIPER, () => {
        reSliderMobile.swiper = new Swiper(selectorSlider.reSliderMobile, {
            slidesPerView: 1.2,
            loop: false,
            speed: 300,
            touchRatio: 0.5,
            spaceBetween: 20,
            centeredSlides: true,
            grabCursor: true,
            a11y: {
                prevSlideMessage: `Вперёд`,
                nextSlideMessage: `Назад`,
            },
            pagination: {
                el: `.re-slider-mobile__pagination`,
                bulletClass: `re-slider-mobile__pagination-item`,
                bulletActiveClass: `re-slider-mobile__pagination-item--active`,
                clickable: true,
            },
            breakpoints: {
                0:{
                    slidesPerView: 1.1,
                    centeredSlides: false,
                    freeMode: true,
                    freeModeSticky: true,
                    grabCursor: true,
                    allowTouchMove: true,
                },
                520:{
                    slidesPerView: 1.6,
                    centeredSlides: false,
                    freeMode: true,
                    freeModeSticky: true,
                    grabCursor: true,
                    allowTouchMove: true,
                },
                767: {
                    slidesPerView: `auto`,
                    centeredSlides: false,
                    init: false,
                    freeMode: false,
                    freeModeSticky: false,
                    grabCursor: false,
                    allowTouchMove: false,
                    spaceBetween: 0,
                },
            },
            on: {
                slideNextTransitionStart() {
                    isInit = true
                },
                transitionEnd() {
                    fixToIntPixel(this);
                },
                resize() {
                    isDesktopWidth = calculatingWidth();
                }
            }
        });

        setTimeout(() => {
            App.W.on('resized', reinitReSliderMobile);
        }, 500);
    })
};


function reinitReSliderMobile() {
    App.W.off('resized', reinitReSliderMobile);
    if (reSliderMobile.swiper && reSliderMobile.swiper.destroy) reSliderMobile.swiper.destroy();
    if (reSliderMobile.swiper && reSliderMobile.swiper[0]){
        reSliderMobile.swiper.forEach((slider) => slider.destroy());
    }
    reSliderMobile.swiper = null;
    reSliderMobile.init();
}

// Слайдер в больших баннерах на конструкторе
let sliderBnrLoop = !$(this).is('[data-noloop]');
let dynamicBulletsBool = false;
if (App.H.hasClass('page-constructor')) {
    sliderBnrLoop = false;
    dynamicBulletsBool = true;
}
if ($('.banner-main--ginekology').length > 0) {
    dynamicBulletsBool = true;
}
let optionsConstructor = {
    slidesPerView: 1,
    loop: sliderBnrLoop,
    pagination: {
        el: `.slider-banner__pagination`,
        bulletClass: `slider-banner__pagination-item`,
        bulletActiveClass: `slider-banner__pagination-item--active`,
        clickable: true,
        dynamicBullets: dynamicBulletsBool,
        dynamicMainBullets: 3,
    },
    navigation: {
        nextEl: '.slider-banner-next',
        prevEl: '.slider-banner-prev',
    },
    on: {
        init() {
            setSliderCirclesAnimation(selectorSlider.bannerConstructor, this.activeIndex);
        },
        slideChange() {
            setSliderCirclesAnimation(selectorSlider.bannerConstructor, this.activeIndex);
        },
        transitionEnd() {
            fixToIntPixel(this);
        },
    }
};
let constructorBannerSwiper;
if ($(selectorSlider.bannerConstructor).length) {
    $(selectorSlider.bannerConstructor).each(function () {
        let sliderDelay = $(this).data('autoplay') || 9999999;
        optionsConstructor = Object.assign(optionsConstructor, {
            autoplay: {
                delay: sliderDelay,
                disableOnInteraction: false
            }
        });
        constructorBannerSwiper = {
            init: () => loadLibrary(LIB_URL.SWIPER, () => {
                new Swiper(this, optionsConstructor);

                if ($(selectorSlider.bannerConstructor).find('.swiper-slide-duplicate')) {
                    $(selectorSlider.bannerConstructor).find('.swiper-slide-duplicate').each(function () {
                        if ($(this).find('h1').length) {
                            const h1 = $(this).find('h1');
                            const attrs = $(this).find('h1')[0].attributes;

                            const div = document.createElement('div');
                            for (let i = 0; i < attrs.length; i++) {
                                div.setAttribute(attrs[i].name, attrs[i].value);
                            }
                            $(div).html(h1.html());

                            h1.after(div);
                            h1.remove();
                        }
                        ;
                    });
                }
            })
        };
        constructorBannerSwiper.init();
    });
}

sliderNews = {
    init: () => loadLibrary(LIB_URL.SWIPER, () => {
        sliderNews.swiper = new Swiper(selectorSlider.news, {
            slidesPerView: `auto`,
            loop: true,
            speed: 300,
            touchRatio: 0.5,
            freeMode: true,
            freeModeSticky: true,
            //freeModeMomentum: false,
            freeModeMomentumRatio: 0.5,
            freeModeMomentumVelocityRatio: 0.1,
            //freeModeMomentumBounce: false,
            freeModeMomentumBounceRatio: 1,
            freeModeMinimumVelocity: 0.02,
            /*spaceBetween: 16,*/
            centeredSlides: true,
            grabCursor: true,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            a11y: {
                prevSlideMessage: `Вперёд`,
                nextSlideMessage: `Назад`,
            },
            on: {
                init() {
                    // if (isDesktopWidth) {
                    //     this.slides[this.activeIndex].style.marginRight = `8px`;
                    //     this.slides[this.activeIndex].style.marginLeft = `-22px`;
                    // }
                },
                slideNextTransitionStart() {
                    //setMargins(direction.FORWARD, this.slides, this.previousIndex, this.activeIndex);
                    isInit = true
                },
                slidePrevTransitionStart() {
                    //setMargins(direction.BACK, this.slides, this.previousIndex, this.activeIndex);
                },
                transitionEnd() {
                    fixToIntPixel(this);
                },
                slideChange() {
                    setMargins(direction.BACK, this.slides, this.previousIndex, this.activeIndex);
                },
                resize() {
                    isDesktopWidth = calculatingWidth();
                }
            }
        });

        setTimeout(() => {
            App.W.on('resized', reinitSliderNews);
        }, 500);
    })
};

function reinitSliderNews() {
    App.W.off('resized', reinitSliderNews);
    if (sliderNews.swiper && sliderNews.swiper.destroy) sliderNews.swiper.destroy();
    if (sliderNews.swiper && sliderNews.swiper[0]){
        sliderNews.swiper.forEach((slider) => slider.destroy());
    }
    sliderNews.swiper = null;
    sliderNews.init();
}

sliderReNews = {
    init: () => loadLibrary(LIB_URL.SWIPER, () => {
        sliderReNews.swiper = new Swiper(selectorSlider.reNews, {
            slidesPerView: `auto`,
            loop: true,
            speed: 300,
            touchRatio: 0.5,
            freeMode: true,
            freeModeSticky: true,
            //freeModeMomentum: false,
            freeModeMomentumRatio: 0.5,
            freeModeMomentumVelocityRatio: 0.1,
            //freeModeMomentumBounce: false,
            freeModeMomentumBounceRatio: 1,
            freeModeMinimumVelocity: 0.02,
            spaceBetween: 0,
            centeredSlides: true,
            grabCursor: true,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            pagination: {
                el: `.re-slider-news__pagination`,
                bulletClass: `re-slider-news__pagination-item`,
                bulletActiveClass: `re-slider-news__pagination-item--active`,
                clickable: true,
            },
            a11y: {
                prevSlideMessage: `Вперёд`,
                nextSlideMessage: `Назад`,
            },
            breakpoints: {
                768: {
                    spaceBetween: 20,
                    centeredSlides: false,
                },
                1490: {
                    spaceBetween: 40,
                },
                1600: {
                    spaceBetween: 100,
                },
            },
            on: {
                init(swiper) {
                    // if (isDesktopWidth) {
                    //     this.slides[this.activeIndex].style.marginRight = `8px`;
                    //     this.slides[this.activeIndex].style.marginLeft = `-22px`;
                    // }
                },
                slideNextTransitionStart() {
                    //setMargins(direction.FORWARD, this.slides, this.previousIndex, this.activeIndex);
                    isInit = true
                },
                slidePrevTransitionStart() {
                    //setMargins(direction.BACK, this.slides, this.previousIndex, this.activeIndex);
                },
                transitionEnd() {
                    fixToIntPixel(this);
                },
                slideChange() {
                    //setMargins(direction.BACK, this.slides, this.previousIndex, this.activeIndex);
                },
                resize() {
                    isDesktopWidth = calculatingWidth();
                }
            }
        });

        setTimeout(() => {
            App.W.on('resized', reinitSlideReNews);
        }, 500);
    })
};

function reinitSlideReNews() {
    App.W.off('resized', reinitSlideReNews);
    if (sliderReNews.swiper && sliderReNews.swiper.destroy) sliderReNews.swiper.destroy();
    if (sliderReNews.swiper && sliderReNews.swiper[0]){
        sliderReNews.swiper.forEach((slider) => slider.destroy());
    }
    sliderReNews.swiper = null;
    sliderReNews.init();
}

App.W.on('load', function () {
    if (App.mobile && App.W.outerWidth() < 768) {
        setSliderNavigationForMobile();
    }
});

// слайдер продуктов на главной
const sliderProductsOptions = {
    slidesPerView: `auto`,
    loop: true,
    pagination: {
        el: `.slider-products__pagination`,
        bulletClass: `slider-products__pagination-item`,
        bulletActiveClass: `slider-products__pagination-item--active`,
        clickable: true,
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    a11y: {
        prevSlideMessage: `Вперёд`,
        nextSlideMessage: `Назад`,
    },
    spaceBetween: 30,
    centeredSlides: true,
    grabCursor: true,
    breakpoints: {
        768: {
            slidesPerView: 3,
            slidesPerGroup: 3,
        },
        1490: {
            slidesPerView: 4,
            slidesPerGroup: 4,
            centeredSlides: false,
        },
    },
    on: {
        transitionEnd() {
            fixToIntPixel(this);
        },
    }
};

function getSliderOptions(index) {
    let sliderLoop = !$(this).is('[data-noloop]');
    let dynamicBulletsBool = false;
    if (App.H.hasClass('page-constructor')) {
        sliderLoop = false;
        dynamicBulletsBool = true;
    }
    return {
        slidesPerView: `auto`,
        loop: sliderLoop,
        pagination: {
            el: `.slider-products__pagination.slider-products__pagination-${index}`,
            bulletClass: `slider-products__pagination-item`,
            bulletActiveClass: `slider-products__pagination-item--active`,
            clickable: true,
            dynamicBullets: dynamicBulletsBool,
        },
        navigation: {
            nextEl: `.swiper-button-next.swiper-button-next-${index}`,
            prevEl: `.swiper-button-prev.swiper-button-prev-${index}`,
        },
        a11y: {
            prevSlideMessage: `Вперёд`,
            nextSlideMessage: `Назад`,
        },
        spaceBetween: 30,
        centeredSlides: true,
        grabCursor: true,
        breakpoints: {
            768: {
                slidesPerView: 3,
                slidesPerGroup: 3,
            },
            1490: {
                slidesPerView: 4,
                slidesPerGroup: 4,
                centeredSlides: false,
            },
        },
        on: {
            transitionEnd() {
                //console.log('transition change');
                fixToIntPixel(this);
            },
        }
    };
}

const sliderProducts = {
    init: function () {
    }
};

App.W.on('load', function () {
    setTimeout(function () {
        for (let i = 0; i < $(selectorSlider.products).length; i++) {
            let currOptions = getSliderOptions(i);
            let $currSlider = $(selectorSlider.products).eq(i).closest('.slider');

            $(selectorSlider.products).eq(i).addClass(`slider-products-${i}`);
            $currSlider.find('.slider-products__pagination').addClass(`slider-products__pagination-${i}`);
            $currSlider.find('.swiper-button-prev').addClass(`swiper-button-prev-${i}`);
            $currSlider.find('.swiper-button-next').addClass(`swiper-button-next-${i}`);

            const sliderProductsCount = $currSlider.find('.swiper-slide').length;
            let sliderProductsPerView = getSlidesPerView(currOptions);

            if (sliderProductsCount > 1 && (sliderProductsPerView == 'auto' || sliderProductsPerView < sliderProductsCount)) {
                loadLibrary(LIB_URL.SWIPER, () => {
                    new Swiper(`.slider-products-${i}`, currOptions);
                });
                //console.log('new swiper');
            } else {
                $currSlider.add('_controls-off');
                //document.querySelector(selectorSlider.products) && document.querySelector(selectorSlider.products).classList.add('_controls-off');
            }
        }
    }, 200);
});


//new Swiper(selectorSlider.products, sliderProductsOptions);

function getSlidesPerView(options) {
    if (options.breakpoints) {
        let breakpoints = Object.keys(options.breakpoints).sort((a, b) => {
            if (+a > +b) return -1;
            if (+a == +b) return 0;
            if (+a < +b) return 1;
        });

        for (let i = 0; i < breakpoints.length; i++) {
            if (window.innerWidth > breakpoints[i]) return options.breakpoints[breakpoints[i]].slidesPerView || 1;
        }
    }
    return options.slidesPerView || 1;
}

function setSliderNavigationForMobile() {
    $('.banner-main--bg-mobile-top').each(function (index, el) {
        const $currSlider = $(el);
        const sliderTopPosition = $currSlider.find('.banner-main__bg-wrap').outerHeight() / 2;

        $currSlider.find('.slider-banner-prev').css({top: `${sliderTopPosition}px`});
        $currSlider.find('.slider-banner-next').css({top: `${sliderTopPosition}px`});
    });
}

sliderSteps = {
    init: () => loadLibrary(LIB_URL.SWIPER, () => {
        sliderSteps.swiper = new Swiper(selectorSlider.sliderSteps, {
            slidesPerView: 1,
            // pagination: {
            //     el: ".swiper-pagination",
            //     clickable: true,
            //     dynamicBullets: true,
            //     dynamicMainBullets: 3,
            //     renderBullet: function (index, className) {
            //         return `<span class="how-to-order__swiper-toggle ${className}">${index + 1} шаг</span>`;
            //     },
            // },
            thumbs: {
                swiper: {
                    el: selectorSlider.sliderStepsThumb,
                    slidesPerView: 'auto'
                },
            },
            spaceBetween: 20,
            scrollbar: {
                el: ".swiper-scrollbar",
                hide: false,
            },
        });
    }),
    destroy: () => {
        if (sliderSteps.swiper && sliderSteps.swiper.destroy) sliderSteps.swiper.destroy(true, true);
        sliderSteps.swiper = null;
    }
};

sliderStepsThumb = {
    init: () => loadLibrary(LIB_URL.SWIPER, () => {
        sliderStepsThumb.swiper = new Swiper(selectorSlider.sliderStepsThumb, {
            slidesPerView: 'auto',
            spaceBetween: 8,
        });
    }),
    destroy: () => {
        if (sliderStepsThumb.swiper && sliderStepsThumb.swiper.destroy) sliderStepsThumb.swiper.destroy(true, true);
        sliderStepsThumb.swiper = null;
    }
};

export {
    multipleBannerSwiper,
    multipleReBannerSwiper,
    sliderNews,
    sliderReNews,
    sliderProducts,
    constructorBannerSwiper,
    reSlider,
    reSliderCardio,
    reSliderCardioTagSwapper,
    reSliderStories,
    reSliderPopular,
    reSliderAjax,
    reSliderMobile,
    dataContactsBlockTabsSwiper,
    sliderSteps,
    sliderStepsThumb
};
